import { request } from "shared/api/request"
import {
  ProjectImportS3UploadsAPIType,
  serializer
} from "shared/api/serializer/serializer"
import { transformJsonApiResponse } from "shared/api/transformJsonApiResponse"
import {
  PresignedUrlData,
  uploadToPresignedUrl
} from "shared/api/uploadToPresignedUrl"
import { Logger } from "shared/lib/Logger"
import { useEvent } from "shared/lib/useEvent"
import { ApiResponse } from "shared/types/ApiResponse"
import { FilePreview } from "shared/types/File"

import { z } from "zod"

const PresignedUrlResponseSchema = z.object({
  id: z.string(),
  url: z.string(),
  fields: z.record(z.string(), z.string())
})

async function fetchUploadUrl(): Promise<PresignedUrlData & { id: string }> {
  const response = await request(
    `${import.meta.env.VITE_API_BASE}/project-list/projects/imports/upload-url`
  )
  const json = await response.json()
  const deserialized = serializer.deserialize(
    ProjectImportS3UploadsAPIType,
    transformJsonApiResponse(json)
  )
  return PresignedUrlResponseSchema.parse(deserialized)
}

export function useXlsxUpload(): {
  uploadXlsx: (file: FilePreview) => Promise<ApiResponse<{ s3Key: string }>>
} {
  const uploadXlsx = useEvent(
    async (file: FilePreview): Promise<ApiResponse<{ s3Key: string }>> => {
      try {
        const data = await fetchUploadUrl()
        await uploadToPresignedUrl(data, file.file)
        return {
          data: { s3Key: data.fields.key }
        }
      } catch (error) {
        Logger.error(error, "useXlsxUpload.uploadXlsx")
        return {
          data: null,
          errors: [
            {
              message:
                error instanceof Error ? error.message : "XLSX upload failed"
            }
          ]
        }
      }
    }
  )

  return { uploadXlsx }
}
